// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"500":"267b5afd","952":"901c5ed7"}[chunkId] + ".chunk.js";
};